
import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { exemptionEndPoints, onBoardingEndPoints } from '@src/constants/endpoints-constants';
import { config } from '@uhg-abyss/web/tools/config';
const _httpService = new HttpService();
if (checkIsInternal()) {
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}
export const getOnboardingData = async (payload: any) => {
     try {
                const { page, includeUnPublish } = payload;
                const response: any = await _httpService.get(
                    `${onBoardingEndPoints.list}${page}&includeUnPublish=${includeUnPublish}`,
                );
                return response;
            }
            catch {
                return { Data: {} };
            }
}
// save onoarding list
export const saveOnboardingData = async (payload: any) => {
    try {
            const responseData: any = await _httpService.push(onBoardingEndPoints.save, payload);
            return responseData;
        } catch(error) {
            return { status: false, error };
        }
}

export const getOnboardingImages = async (payload: any) => {
    try {
               const response: any = await _httpService.get(
                   `${onBoardingEndPoints.images}`,
               );
               return response;
           }
           catch {
               return { Data: {} };
           }
}

export const unpublishOnboarding = async (payload: any) => {
    try {
            const { pageId, isPublish, updatedBy } = payload;
            const responseData: any = await _httpService.push(
                `${onBoardingEndPoints.unpublish}${pageId}?isPublish=${isPublish}&updatedBy=${encodeURIComponent(updatedBy)}`,
                {}
            );
            return responseData;
        } catch(error) {
            return { status: false, error };
        }
}


